import React, { useState } from 'react';
import { Col, Container } from 'react-bootstrap';
import debounce from 'lodash.debounce';
import CategoriesSelection from '../Customization/CategoriesSelection';
import ComplementaryItems from '../subComponents/ComplementaryItems';
import AddToOrder from '../subComponents/AddToOrder';
import styleClasses from '../try2.module.scss';
import { IItemSelection } from '../../../models/try2Combo';
import { finalOrder } from '../../../helpers/combo';
import { COMBO_TYPE_IS_TRY_2_COMBO } from '../../../constants';
import { OrderNameForm } from '../../../components/OrderAnItem/OrderNameForm/OrderNameForm';
import QuantityCounter from '../../../components/Cart/CartItems/QuantityCounter';
import {useLocation} from "react-router-dom";
import {useStoreLocation} from "../../../context/StoreLocation";
import useGetRewards from "../../../react-query-hooks/useGetRewards";
import {useAuthState} from "../../../context/UserAuthentication";
import {boolean} from "yup";

const ItemsSelections: React.FC<IItemSelection> = (props) => {
  const {
    sectionSelected,
    itemFromApi,
    selectedFilters,
    unrepeatedIngredients,
    handleIngredientSelection,
    order,
    addToOrder,
    handleItemSelection,
    item_id,
    setItemDetails,
    addItemtoCombo,
    handleSyncIngredients,
    isResetTryToComboContext,
    setIsResetTryToComboContext,
    handleComplementaryIngredientSelection,
    handleScroll,
    favourite,
    userId,
    noDressingHandler,
    scrollToItems,
    setScrollToItems,
    favoriteButtonHandler,
    selectedLocation,
    loading,
    category_id,
    showCustomization,
    userType,
    categoryScrollRef,
    orderButtonScrollRef,
    itemDetails,
    editItemQuantity,
    recipient_name,
    routeStates
  } = props;

  const [quantity, setQuantity] = useState<number>(editItemQuantity ?? 1);
  const [madeForName, setMadeForName] = useState<string>(recipient_name ?? '');


  const selectedOrder = () => {
    let result = [];
    order.modifiers.map((itemModifier) => {
      if (itemModifier.item === sectionSelected) {
        result = itemModifier;
      }
    });
    return result;
  };

  const selectedItems = () => {
    let result = [];
    order.modifiers.map((itemModifier) => {
      if (itemModifier.is_selected) {
        result.push(itemModifier);
      }
    });
    return result;
  };

  const selectedIngredients = (orderItem) => {
    return orderItem.modifiers;
  };

  const showCompletmentary = () => {
    let show: boolean = true;
    if (order?.name) {
      for (let i = 0; i < order?.modifiers.length - 1; i++) {
        if (!order?.modifiers[i]?.is_selected) {
          show = false;
        }
      }
      return show
    } else {
      return false;
    }
  }

  const { authInfo } = useAuthState();
  const { locationInfo } = useStoreLocation();
  const { data: allRewards = [] } = useGetRewards(
      authInfo.userId,
      locationInfo.selectedStore?.id,
      1,
      1,
      1,
      authInfo?.type
  );
  const handleAddToOrder = () => {
    const finalOrderObject: any = finalOrder({ order, category_id, noOfItems: 2, comboType: COMBO_TYPE_IS_TRY_2_COMBO, items: itemFromApi, state: routeStates, allRewards: allRewards})
    finalOrderObject.recipient_name = madeForName;
    if (quantity) finalOrderObject.quantity = quantity;
    addToOrder(finalOrderObject);
    setQuantity(1)
    setMadeForName('')
  }

  return (
    <>
      {!sectionSelected ? (
        <>
          {showCompletmentary() &&
            <div className={styleClasses.comple_wrap} ref={orderButtonScrollRef}>
              <ComplementaryItems
                itemFromApi={itemFromApi}
                unrepeatedIngredients={unrepeatedIngredients}
                handleIngredientSelection={handleComplementaryIngredientSelection}
                order={order}
                itemNo={3}
                items_count="col-4"
              />
              <div className={styleClasses.order_name_form_wrap}>
                {/* <Col lg="6" md="6" className='mx-auto px-3'> */}
                <OrderNameForm try2ComboPadding={'pe-3'} setQuantity={(quantity: number) => setQuantity(quantity)}
                               isRedeemedItem={routeStates?.isItemRedeemed || routeStates?.isReward}
                               quantity={quantity} madeFor={madeForName} setMadeForName={(name: string) => setMadeForName(name)} />
                {/* </Col> */}

              </div>
              <div className='mb-md-0 mb-3'>
              <AddToOrder order={order} loading={loading} addToOrder={handleAddToOrder} showCustomization={showCustomization} />
              </div>
            </div>}

        </>
      ) : (
        <div ref={categoryScrollRef}>
          <CategoriesSelection
            handleClick={handleItemSelection}
            selectedCategories={selectedItems() || []}
            item_id={item_id}
            categories={itemFromApi?.sub_categories}
            selectedFilters={selectedFilters}
            itemState={setItemDetails}
            isResetTryToComboContext={isResetTryToComboContext}
            selectedIngredients={selectedIngredients(selectedOrder())}
            handleIngredientSelection={handleIngredientSelection}
            addItemtoCombo={addItemtoCombo}
            sectionSelected={sectionSelected}
            handleSyncIngredients={handleSyncIngredients}
            setIsResetTryToComboContext={setIsResetTryToComboContext}
            handleScroll={handleScroll}
            favourite={favourite}
            favoriteButtonHandler={favoriteButtonHandler}
            userId={userId}
            userType={userType}
            noDressingHandler={noDressingHandler}
            scrollToItems={scrollToItems}
            setScrollToItems={setScrollToItems}
            selectedLocation={selectedLocation}
            itemDetails={itemDetails}
          />
        </div>
      )}
    </>
  );
};

export default ItemsSelections;
